var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty"},[_c('img',{attrs:{"src":require('../assets/imgs/empty/'+_vm.icon+'.png'),"alt":""}}),_c('div',{staticClass:"tip"},[_vm._v(_vm._s(_vm.tip))]),_c('div',{staticClass:"btn",on:{"click":_vm.btnClick}},[_vm._v(_vm._s(_vm.btn))])])
}
var staticRenderFns = []

export { render, staticRenderFns }